import { Component, Input, OnInit } from "@angular/core";

import { FormControl } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { BaseComponent } from "app/base-module/base-component/base.component";
import { AuthService } from "app/base-module/base-service/auth.service";
import { UtilitesService } from "app/base-module/base-service/utilites.service";
import { Estrategia } from "app/renda-variavel/models/estrategia.model";
import { PainelService } from "app/renda-variavel/services/painel.service";
import { CadastraItemPainelComponent } from "../cadastra-item-painel/cadastra-item-painel.component";

interface EstrategiaPainel extends Estrategia {
    total_trades_abertos: number;
    total_trades_fechados: number;
    total_volume_efetivado: number;
    custodia_estrategia: number;
}

@Component({
    selector: "painel-renda-variavel",
    templateUrl: "./lista.component.html",
    styleUrls: ["./lista.component.scss"],
    providers: [PainelService],
})
export class ListaComponent extends BaseComponent implements OnInit {
    @Input() cliente_id!: number;

    date = new Date();

    primeiroDia = this._utilitesService.primeiroDiaMes();
    ultimoDia = this._utilitesService.ultimoDiaMes();

    data_operacao_inicio = new FormControl(this.primeiroDia);
    data_operacao_fim = new FormControl(this.ultimoDia);

    user: any;
    data_atualizacao: any;
    listEstrategia: EstrategiaPainel[] = [];
    currentDate = new Date();

    constructor(
        public dialog: MatDialog,
        override snackBar: MatSnackBar,
        private _authService: AuthService,
        private _estrategiaPainelService: PainelService,
        private _utilitesService: UtilitesService
    ) {
        super(dialog, snackBar);
        const strUser = this._authService.getUser();
        this.user = JSON.parse(strUser ? strUser : "{}");
    }

    ngOnInit() {
        this.getAllEstrategiasPosicaoCliente();
    }

    /**
     * Modal de cadastro de Custódia
     */
    openCadastro(): void {
        const dialogRef = this.dialog.open(CadastraItemPainelComponent, {
            width: "600px",
            maxHeight: "99vh",
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result != undefined && result != null && result != "cancel") {
                this.showSuccess("Painel atualizada com Sucesso!");
                this.getAllEstrategiasPosicaoCliente();
            } else if (result != undefined && result != "cancel") {
                this.showError(
                    "Ocorreu um erro ao tentar atualizar o registro"
                );
            }
        });
    }

    getAllEstrategiasPosicaoCliente() {
        this.openLoading();
        const params = {
            cliente_id: this.cliente_id,
            is_visible_painel: true,
        };

        this._estrategiaPainelService.getAllEstrategias(params).subscribe(
            (list) => {
                this.listEstrategia = list.data;
            },
            (error) => {
                this.closeLoading();
            },
            () => {
                this.closeLoading();
            }
        );
    }

    refreshItem(event: any) {
        if (event) {
            this.getAllEstrategiasPosicaoCliente();
        }
    }
}
